import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets the window scroll position to the top whenever the route
 * changes. Mounted once near the router root so every navigation
 * (link click, browser-driven Back/Forward, programmatic navigate())
 * starts the next page at the top instead of inheriting whatever
 * scroll position the previous page was at.
 *
 * Hash links (#how, #pricing, #faq) are left alone — those should
 * scroll to the anchored section, not to the page top. The browser's
 * native anchor handling takes care of that case for us.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // let the hash anchor handle its own scroll
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}
